module.exports = "<div class=\"row\">\n    <div class=\"col-md-10\">\n        <app-clients></app-clients>\n    </div>\n    <div class=\"col-md-2\">\n        <app-sidebar></app-sidebar>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/clientpanel/src/app/components/dashboard/dashboard.component.html
// module id = ../../../../../src/app/components/dashboard/dashboard.component.html
// module chunks = main